import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {selectEnv} from 'reducers/env';

import {persist} from '../reducer';

const namespace = 'flows/interest/accreditation';

// Actions
const LOAD_INTEREST_ACCREDITATION = defineAction('LOAD_INTEREST_ACCREDITATION', namespace);
const SUBMIT_INTEREST_ACCREDITATION = defineAction('SUBMIT_INTEREST_ACCREDITATION', namespace);

export const loadInterestAccreditation = createAction(LOAD_INTEREST_ACCREDITATION.ACTION);
export const submitInterestAccreditation = createAction(SUBMIT_INTEREST_ACCREDITATION.ACTION);

// Interest Accreditation Saga
export function* interestAccreditationSaga() {
  // TODO: rehydrate investor details from allocation

  // Wait for user to click next
  const action = yield take(SUBMIT_INTEREST_ACCREDITATION.ACTION);

  // Save should save the investor info to the interest reducer
  yield put(persist({accreditation: action.payload}));

  // Take them to the next page
  const env = yield select(selectEnv);
  if (env.web) {
    yield call(browserHistory.push, '/interest/investment');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_ACCREDITATION.ACTION, interestAccreditationSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/accreditation/index.js